import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { AuthLayout, FormError } from "../components/AuthLayout";

export default function Forgot() {
  const nav = useNavigate();
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async (fn) => {
    setBusy(true);
    setError("");
    try { await fn(); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  const sendCode = (e) => {
    e.preventDefault();
    run(async () => {
      await api.post("/auth/forgot-password", { email });
      setStep("code");
      toast.success("If that email has an account, a code is on its way");
    });
  };

  const reset = (e) => {
    e.preventDefault();
    run(async () => {
      await api.post("/auth/reset-password", { email, code, new_password: password });
      toast.success("Password updated — log in with your new password");
      nav("/login");
    });
  };

  return (
    <AuthLayout title="Reset password"
      subtitle={step === "email" ? "We'll email you a 6-digit code." : `Enter the code sent to ${email}. It expires in 15 minutes.`}>
      {step === "email" ? (
        <form onSubmit={sendCode} className="space-y-5" data-testid="forgot-email-form">
          <div>
            <label className="brut-label">Email</label>
            <input className="brut-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </div>
          <FormError msg={error} testId="forgot-error" />
          <button className="brut-btn w-full" disabled={busy} data-testid="forgot-send-code-btn">{busy ? "Sending…" : "Send code"}</button>
        </form>
      ) : (
        <form onSubmit={reset} className="space-y-5" data-testid="forgot-reset-form">
          <div>
            <label className="brut-label">6-digit code</label>
            <input className="brut-input tracking-[0.5em] text-2xl text-center" inputMode="numeric" maxLength={6} required
              pattern="\d{6}" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} data-testid="forgot-code-input" />
          </div>
          <div>
            <label className="brut-label">New password (8+ characters)</label>
            <input className="brut-input" type="password" minLength={8} required value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="forgot-new-password-input" />
          </div>
          <FormError msg={error} testId="forgot-error" />
          <button className="brut-btn w-full" disabled={busy} data-testid="forgot-reset-btn">{busy ? "Saving…" : "Set new password"}</button>
          <button type="button" className="text-sm text-zinc-400 underline" onClick={() => setStep("email")} data-testid="forgot-resend-btn">
            Didn't get it? Send a new code
          </button>
        </form>
      )}
      <p className="mt-6 text-sm"><Link to="/login" className="text-[#FF4D00] font-bold" data-testid="forgot-login-link">Back to log in</Link></p>
    </AuthLayout>
  );
}
